(() => {
  function toggleAddon(widget, item) {
    const itemLabel = item.querySelector('.rebuy-checkbox-label');
    const rebuyLabels = widget.querySelectorAll('.rebuy-checkbox-label');

    item.classList.toggle('checked');

    for (var i = 0; i < rebuyLabels.length; i++) {
      const label = rebuyLabels[i];
      const checkbox = label.querySelector('input');

      if (label == itemLabel) { continue; }

      if (checkbox.checked) {
        checkbox.click(); // Trigger rebuy uncheck
        label.closest('.rebuy-addon__item').classList.remove('checked');
      }
    }
  }

  async function showAddonModal(href) {
    const popup = document.querySelector('[data-addon-popup]');
    if (!popup) return Promise.resolve();

    return fetch(href + '&section_id=product-variant-preview')
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const preview = html.querySelector('.product-variant-preview');

        if (preview) {
          popup.setContent(preview);
          popup.open();
        }

        return { popup };
      });
  }

  function initModalSlider(container, variantIndex = 0) {
    var mainSliderArgs = {
      adaptiveHeight: true,
      avoidReflow: true,
      initialIndex: variantIndex,
      childNav: container.querySelector('[data-product-thumbs]'),
      childNavScroller: container.querySelector('.product__thumbs--scroller'),
      pageDots: true, // mobile only with CSS
      wrapAround: true,
    };

    const mainSlider = container.querySelector('[data-product-photos]');
    if (!mainSlider) return;

    container.flickity = new theme.Slideshow(mainSlider, mainSliderArgs);
  }

  async function onRebuyWidgetClick(event) {
    const { target, currentTarget: widget } = event;

    if (target.type == 'checkbox' || !widget.classList.contains('widget-type-product-addon')) return;

    const item = target.closest('.rebuy-addon__item');
    if (!item) return;

    if (target.classList.contains('rebuy-addon__item-info-link')) {
      event.preventDefault();
      await handleInfoLinkClick(target, item);
    } else {
      toggleAddon(widget, item);
    }
  }

  async function handleInfoLinkClick(target, item) {
    target.classList.add('waiting');
    const modalResult = await showAddonModal(target.href);
    target.classList.remove('waiting');

    if (modalResult) {
      const { popup } = modalResult;
      const selectAddonButton = popup.querySelector('[data-select-addon]');

      if (selectAddonButton) {
        selectAddonButton.addEventListener('click', () => {
          selectItem(item);
        });
      }

      initModalSlider(popup, getVariantIndex(popup));
      if (window.AOS) { AOS.refreshHard() }
    }
  }

  function getVariantIndex(container) {
    const mediaId = container.querySelector('[data-featured-media]')?.dataset?.featuredMedia;
    const variantIndex = container.querySelector(`.product__thumb-item [data-id="${mediaId}"]`)?.dataset?.index;
    return parseInt(variantIndex, 10);
  }

  function selectItem(item) {
    if (!item || item.classList.contains('checked')) return;

    const itemLabel = item.querySelector('.rebuy-checkbox-label');
    itemLabel.click();
  }

  // For some reason preventing the click event on the original "Learn More" link doesn't work
  // so we make a clone.
  function cloneMoreLink(widget) {
    const items = widget.querySelectorAll('.rebuy-addon__item');

    items.forEach((item) => {
      const moreLink = item.querySelector('.rebuy-addon__item-learn-more-link');
      if (!moreLink) return;

      const clonedLink = document.createElement('a');
      clonedLink.classList.add('rebuy-addon__item-info-link');
      clonedLink.href = moreLink.href;

      item.appendChild(clonedLink);
    });
  }

  document.addEventListener('rebuy.ready', (event) => {
    const eventWidget = event.detail.widget;
    const domWidget = document.getElementById(`rebuy-widget-${eventWidget.element.dataset.rebuyId}`);

    if (domWidget) {
      cloneMoreLink(domWidget);
      domWidget.addEventListener('click', onRebuyWidgetClick);
    }
  });
})();
